import { ALL_TASKS } from "src/business-components/input/TaskSelector/TaskSelector.constants";

export const FORM_SX = { minWidth: 120, maxWidth: "none" } as const;
export const BASE_COLOR_CLS = "";
export const COMPARE_COLOR_CLS = "";
export const COMPARISON_HISTORY_SIZE_LIMIT = 20; // maximum 20 history items

/** URL query keys for compare-runs form (paired values use `~~` in a single param). */
export const SEARCH_PARAM_NAMES = {
  env: "env",
  pipeline: "pipeline",
  pit: "pit",
  task: "task",
} as const;

export const COMPARE_RUNS_QUERY_PARAM_NAMES = [
  SEARCH_PARAM_NAMES.env,
  SEARCH_PARAM_NAMES.pipeline,
  SEARCH_PARAM_NAMES.pit,
  SEARCH_PARAM_NAMES.task,
] as const;

export const DEFAULT_TASK = ALL_TASKS + "-" + 0;
export const PAIR_DELIMITER = "~~";
